import { render } from "./RackBatteryStat.vue?vue&type=template&id=823b3956&scoped=true"
import script from "./RackBatteryStat.vue?vue&type=script&lang=js"
export * from "./RackBatteryStat.vue?vue&type=script&lang=js"

import "./RackBatteryStat.vue?vue&type=style&index=0&id=823b3956&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823b3956"]])

export default __exports__